module.exports = __webpack_public_path__ + "assets/42afa29cfa1228a2c2a8c223a2f0201e.svg";